import React from 'react';
import { Route } from 'react-router-dom';
import Notificaciones from './Components/Notificaciones';
import AjustesNotificaciones from './Components/AjustesNotificaciones';

export default class AdmNotificaciones extends React.Component {

  render () {
    return (
      <div>
        <Route exact path="/Notificaciones" component={Notificaciones}/>
        <Route exact path="/Notificaciones/Ajustes" component={AjustesNotificaciones}/>
      </div>
    );
  }
}